import AvatarCanvas from './AvatarCanvas'
export default AvatarCanvas
